import {
  createContext,
  type FC,
  type ReactNode,
} from "preact/compat";
import {
  useRef,
  useState,
  useEffect,
  type MutableRef,
} from "preact/hooks";

export const ModalContext = createContext(null);

export type ComboboxModalProviderProps = {
  children: ReactNode;
};
export const ComboboxModalProvider: FC<ComboboxModalProviderProps> = ({ children }) => {
  const modalRef: MutableRef<null | undefined> = useRef();
  const [context, setContext] = useState(null);
  useEffect(() => {
    if (modalRef?.current) {
      setContext(modalRef.current);
    }
  }, [modalRef?.current]);
  return (
    <>
      <ModalContext.Provider value={context}>{children}</ModalContext.Provider>
      <div className="overflow-hidden" ref={modalRef as MutableRef<HTMLDivElement | null>} />
    </>
  );
};
